import { useEffect } from 'react';
import SuperButton from '@app/components/super-button';
import {
  OnlineOrderBranchConfigurationItemFragment,
  BranchItemFragment,
  OnlineOrderItemFragment,
} from '@app/graphql/types/graphql';
import { useTranslate } from '@tolgee/react';

interface WaitingForPaymentPageProps {
  onlineOrder: OnlineOrderItemFragment;
  branch: BranchItemFragment;
  configuration: OnlineOrderBranchConfigurationItemFragment;
}

const WaitingForPaymentPage = ({ onlineOrder }: WaitingForPaymentPageProps) => {
  const { t } = useTranslate();
  useEffect(() => {
    // Auto redirect to Stripe payment page on first load
    if (onlineOrder.invoice?.paymentURL) {
      window.location.href = onlineOrder.invoice.paymentURL;
    }
  }, [onlineOrder.invoice?.paymentURL]);

  const handleRedirectToPayment = () => {
    if (onlineOrder.invoice?.paymentURL) {
      window.location.href = onlineOrder.invoice.paymentURL;
    }
  };

  return (
    <div className="waiting-payment card flex min-h-screen flex-col items-center justify-center p-4">
      <div className="waiting-payment__message w-full max-w-md">
        <h1 className="waiting-payment__instructions mb-4 text-center text-2xl font-bold">{t('online-order.waiting-for-payment.header')}</h1>
        <p className="mb-6 text-center">{t('online-order.waiting-for-payment.description')}</p>
        {onlineOrder.invoice?.paymentURL && (
          <SuperButton onClick={handleRedirectToPayment} className="w-full">
            {t('online-order.waiting-for-payment.button.go-to-payment')}
          </SuperButton>
        )}
      </div>
    </div>
  );
};

export default WaitingForPaymentPage;
